import { apiUrl } from '../config/backend';

let Configuration = { apiUrl: apiUrl("/api/v3/") };
export default Configuration;
